import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { ModalServiceContext } from "./../../ricos-context/ModalContext";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider";
import { useNodeAttrs } from "./../../_shared/use-node-attrs";
import { resolveColorsPalette } from "./../../wix-rich-content-common";
import { DEFAULT_PALETTE } from "./../defaults";
import { NewColorPicker } from "./../../ui-components/color-picker/new-color-picker";
const ButtonColorPicker = ({
  modalId,
  nodeId,
  nodeType,
  colorType,
  isHoverState,
  referenceElement,
  config,
  defaultTextColor,
  defaultBackgroundColor,
  onColorSelected,
  onColorAdded: onColorAddedProp
}) => {
  const modalService = useContext(ModalServiceContext);
  const { t } = useContext(RicosContext);
  const { pmNodeAttrs } = useNodeAttrs(nodeId, nodeType);
  const logBi = useBiNext({
    modalId,
    pluginId: nodeType === "LINK_BUTTON" ? "linkButton" : "actionButton",
    nodeId
  });
  const themeColors = resolveColorsPalette(
    DEFAULT_PALETTE.concat(config.colors ? Object.values(config.colors) : []),
    void 0,
    57
  );
  const resolveCustomColors = (args) => resolveColorsPalette(args.getColorFn?.() ?? [], args.currentColor, 57);
  const [allCustomColors, setAllCustomColors] = useState(() => ({
    textColor: resolveCustomColors({
      currentColor: pmNodeAttrs?.styles?.textColor ?? defaultTextColor,
      getColorFn: config.getTextColors
    }),
    borderColor: resolveCustomColors({
      currentColor: pmNodeAttrs?.styles?.borderColor ?? defaultBackgroundColor,
      getColorFn: config.getBorderColors
    }),
    backgroundColor: resolveCustomColors({
      currentColor: pmNodeAttrs?.styles?.backgroundColor ?? defaultBackgroundColor,
      getColorFn: config.getBackgroundColors
    })
  }));
  const onColorAdded = (color) => {
    onColorAddedProp(color);
    setAllCustomColors((prev) => ({ ...prev, [colorType]: [...prev[colorType], color] }));
    onColorSelected(color);
  };
  const closeModal = () => modalService.closeModal(modalId);
  const onResetColor = () => onColorSelected(void 0);
  const currentColor = pmNodeAttrs?.styles?.[`${colorType}${isHoverState ? "Hover" : ""}`]?.toUpperCase();
  const customColors = allCustomColors[colorType];
  return /* @__PURE__ */ React.createElement(
    NewColorPicker,
    {
      themeColors,
      customColors,
      currentColor,
      title: t("ButtonColourModal_Title"),
      closeModal,
      onColorSelected,
      onColorAdded,
      onResetColor,
      referenceElement,
      logBi
    }
  );
};
export {
  ButtonColorPicker
};
//# sourceMappingURL=button-color-picker.js.map
